module.exports = "import React from 'react';\nimport DatePicker from 'material-ui/DatePicker';\n\n/**\n * Inline Date Pickers are displayed below the input, rather than as a modal dialog.\n */\nconst DatePickerExampleInline = () => (\n  <div>\n    <DatePicker hintText=\"Portrait Inline Dialog\" container=\"inline\" />\n    <DatePicker hintText=\"Landscape Inline Dialog\" container=\"inline\" mode=\"landscape\" />\n  </div>\n);\n\nexport default DatePickerExampleInline;\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/app/components/pages/components/DatePicker/ExampleInline.js
 ** module id = 958
 ** module chunks = 0
 **/